module.exports = __webpack_public_path__ + "static/img/7.86324e1e.png";